var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeUnactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3035 6.3C16.3035 7.50937 16.3035 15.3281 16.3035 16.2844H14.0895C14.0895 1.125 14.0895 10.0406 14.0895 4.6125L8.13738 0V1.35C8.13738 3.09375 8.13738 14.7375 8.13738 16.2844H5.46326C5.46326 10.9969 5.46326 8.63437 5.46326 3.34687L0 7.62188V18H1.75399C1.75399 18 1.75399 16.65 1.75399 8.4375L3.70927 6.91875C3.70927 20.0531 3.70927 15.4125 3.70927 17.9719H9.89137C9.89137 11.4188 9.89137 9.30937 9.89137 3.51562L12.2492 5.25938C12.2492 8.49375 12.2492 14.7656 12.2492 17.9719H18V7.62188L16.3035 6.3Z",
    fill: "#968E53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeUnactive);
export default __webpack_public_path__ + "static/media/icon-home-unactive.fc074648.svg";
export { ForwardRef as ReactComponent };